@use '@design/design-tokens/typography/typography' as *;

.root {
  display: flex;
  gap: 8px;
  align-items: center;
  width: 100%;
}

.flexColumn {
  display: flex;
  flex-direction: column;
  min-width: 0;
}

.selfAlignEnd {
  margin-left: auto;
  display: flex;
}

.titleLabel {
  max-width: 110px;
  @include typography-v2-body-sm;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.subtitleLabel {
  @include typography-v2-body-xs;
  color: var(--text-soft);
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.insightsCell {
  display: flex;
  gap: 4px;
  align-items: center;
}

.insightsCellFixed {
  display: inline-flex;
  gap: 4px;
  align-items: center;
  width: 81px;
}

.placeholder {
  width: 18px;
  height: 18px;
  padding-right: 3px;
}

.moreCount {
  @include typography-v2-body-xs;
  color: var(--text-soft);
  width: 15px;
  height: 16px;
}
